import React from "react";
import { RoutesProps } from "../interfaces";
import { Routes as ReactRoutes, Route } from "react-router-dom";
import ProtectedRoute from "../containers/ProtectedRouteContainer";
import { RouteObject } from "../interfaces/navigation";
import { searchRoutes } from "../pages/Search/routes";
import { publicationRoutes } from "../pages/Publication/routes";
import { frequentQuestionRoutes } from "../pages/FrequentQuestions/routes";
import { loginRoutes } from "../pages/Login/routes";
import { profileRoutes } from "../pages/Profile/routes";
import { sellRoutes } from "../pages/Sell/routes";
import { termsRoutes } from "../pages/Terms/routes";
import { linzeAiRoutes } from "../pages/LinzeAi/routes";
import { notFoundPageRoutes } from "../pages/NotFoundPage/routes";
import SuspenseLoader from "../components/SuspenseLoader";
import { newCarsRoutes } from "../pages/NewCars/routes";

const Routes = ({ fetchingRefreshToken, refreshType }: RoutesProps) => {

    const allRoutes: RouteObject[] = [
        ...searchRoutes,
        ...publicationRoutes,
        ...newCarsRoutes,
        ...loginRoutes,
        ...sellRoutes,
        ...frequentQuestionRoutes,
        ...profileRoutes,
        ...termsRoutes,
        ...linzeAiRoutes,
        ...notFoundPageRoutes
    ];

    return (
        <ReactRoutes>
            {allRoutes.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <React.Suspense fallback={
                            <SuspenseLoader />
                        }>
                            {
                                (fetchingRefreshToken === "loading" && refreshType === "first_initialization")
                                ?   <SuspenseLoader />
                                :   route.protected 
                                    ?   <ProtectedRoute>{route.component}</ProtectedRoute>
                                    :   route.component
                            }
                        </React.Suspense>
                    }
                >
                    {route?.subRoutes?.map((subRoute, index) => {
                        return <Route
                            path={subRoute.path}
                            key={"subRoute-" + index}
                            element={subRoute.protected ?
                                <ProtectedRoute>{subRoute.component}</ProtectedRoute>
                                :
                                subRoute.component
                            }>
                            {subRoute?.subRoutes?.map((subSubRoute, index) => (
                                <Route
                                    path={subSubRoute.path}
                                    key={"subSubRoute-" + index}
                                    element={subSubRoute.component}
                                > 
                                {
                                    subSubRoute?.subRoutes?.map((subSubSubRoute) => (
                                        <Route
                                        path={subSubSubRoute.path}
                                        key={"subSubSubRoute-" + index}
                                        element={subSubSubRoute.component}
                                    /> 
                                    ))
                                }
                                </Route>
                                ))}
                        </Route>
                    })}
                </Route>
            ))}
            <Route 
                path='*' 
                element={
                    <React.Suspense fallback={
                        <SuspenseLoader />
                    }>
                        {notFoundPageRoutes[0].component}
                    </React.Suspense>
                } 
            />
        </ReactRoutes>
    )
};

export default Routes;